import React from 'react';
import { Platform, View } from 'react-native';
import { useRouter } from 'expo-router';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';
import { formatCreditBalance } from '@/lib/formatCredits';

export default function BusinessCreditSummary({ credits, onClose }) {
  const router = useRouter(), company = credits.business;
  return <View style={{ padding: 24, gap: 16 }}>
    <Text size="l" weight="semibold">{company.name}</Text>
    <Text size="xxl" weight="bold">{formatCreditBalance(credits.totalAvailable)} credits available</Text>
    <Text color="secondary">Your normal Gab AI usage uses company credits. Purchased personal credits stay in your account.</Text>
    {company.active === false && <Text color="secondary">Company billing is currently unavailable. Ask your owner to check the subscription, or choose personal billing in Business settings.</Text>}
    {company.limit != null && <Text color="secondary">{formatCreditBalance(company.used || 0)} used of your {formatCreditBalance(company.limit)} credit limit this period.</Text>}
    <Text color="secondary">If you need more credits, ask your Business owner or admin to increase your limit or replenish the company balance.</Text>
    {Platform.OS === 'web' && <Button text="Manage Business" variant="secondary" onPress={() => {
      onClose?.(); router.push(`/settings?tab=business&workspace=${encodeURIComponent(company.id)}`);
    }} />}
  </View>;
}
